export default class AzureActiveDirectoryConfig {
  constructor(
    public clientId: string,
    public authority: string,
    public redirectUri: string,
    public audience: string,
    public scope: string
  ) {}
}
